import React, { Fragment } from "react";
import { Link } from "react-router-dom";
const BlogPosts = ({blog}) => {
  return (
    <Fragment>
      <div className="col-xl-4 col-sm-6 mt-40">
        <div className="blog-wrap-2 mb-30">
          <div className="blog-img-2">
            <Link to={process.env.PUBLIC_URL + `/blog-post/${blog._id}`}>
              <img
                src={process.env.PUBLIC_URL + blog.images && blog.images[0].url}
                alt=""
              />
            </Link>
          </div>
          <div className="blog-content-2">
            {/* <div className="blog-meta-2">
              <ul>
                <li>22 April, 2020</li>
              </ul>
            </div> */}
            <h4>
              <Link to={process.env.PUBLIC_URL + `/blog-post/${blog._id}`}>
                {blog.title}
              </Link>
            </h4>
            <p style={{
              lineBreak: "anywhere",
              fontSize:16
            }}>
             {blog.text.slice(0,40)}
            </p>
            <div className="blog-share-comment">
              <div className="blog-btn-2">
                <Link to={process.env.PUBLIC_URL + 
              `/blog-post/${blog._id}`
                  }>
                  Leer Mas
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BlogPosts;